// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { TargetTypeSchema } from '../inputTypeSchemas/TargetTypeSchema'
import { TraceStatusSchema } from '../inputTypeSchemas/TraceStatusSchema'

/////////////////////////////////////////
// TRACE SCHEMA
/////////////////////////////////////////

export const TraceSchema = z.object({
  targetType: TargetTypeSchema,
  status: TraceStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  targetId: z.string(),
  threadId: z.string(),
  name: z.string(),
  signalId: z.string().nullable(),
  executionId: z.string().nullable(),
  metadata: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Trace = z.infer<typeof TraceSchema>

export default TraceSchema;
